import React, { useEffect, useState } from "react";

const STORES = [
  { id: 6, name: "Niko 1" },
  { id: 3, name: "Niko 2" },
  { id: 1, name: "Niko 3" },
  { id: 2, name: "Niko 4" },
  { id: 4, name: "Niko 5" },
  { id: 5, name: "Niko 7" },
];

const DIAS = ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"];

interface Horario {
  id: number;
  store_id: number;
  dia_semana: number;
  turno: number;
  hora_inicio: string;
  hora_fin: string;
  activo: boolean;
}

interface Props { token: string; }

export default function HorariosPanel({ token }: Props) {
  const [horarios, setHorarios] = useState<Horario[]>([]);
  const [storeSeleccionado, setStoreSeleccionado] = useState(6);
  const [msg, setMsg] = useState("");
  const [editando, setEditando] = useState<{[key: string]: {inicio: string, fin: string}}>({});

  const headers = { "Authorization": "Bearer " + token, "Content-Type": "application/json" };

  const load = () => {
    fetch("/api/horarios", { headers }).then(r => r.json()).then(setHorarios);
  };

  useEffect(() => { load(); }, []);

  const getHorario = (store_id: number, dia: number, turno: number) => {
    return horarios.find(h => h.store_id === store_id && h.dia_semana === dia && h.turno === turno);
  };

  const isDiaActivo = (store_id: number, dia: number) => {
    const h = horarios.filter(h => h.store_id === store_id && h.dia_semana === dia);
    return h.length > 0 && h.some(x => x.activo);
  };

  const toggleDia = async (dia: number, activo: boolean) => {
    if (activo) {
      const t1 = getHorario(storeSeleccionado, dia, 1);
      const t2 = getHorario(storeSeleccionado, dia, 2);
      if (!t1) {
        await fetch("/api/horarios", { method: "POST", headers,
          body: JSON.stringify({ store_id: storeSeleccionado, dia_semana: dia, turno: 1, hora_inicio: "09:00", hora_fin: "13:00", activo: true }) });
      }
      if (!t2) {
        await fetch("/api/horarios", { method: "POST", headers,
          body: JSON.stringify({ store_id: storeSeleccionado, dia_semana: dia, turno: 2, hora_inicio: "17:00", hora_fin: "21:00", activo: true }) });
      }
    }
    await fetch("/api/horarios/toggle", { method: "POST", headers,
      body: JSON.stringify({ store_id: storeSeleccionado, dia_semana: dia, activo }) });
    load();
  };

  const saveHorario = async (dia: number, turno: number) => {
    const key = `${dia}-${turno}`;
    const vals = editando[key];
    if (!vals) return;
    const r = await fetch("/api/horarios", { method: "POST", headers,
      body: JSON.stringify({ store_id: storeSeleccionado, dia_semana: dia, turno, hora_inicio: vals.inicio, hora_fin: vals.fin, activo: true }) });
    const data = await r.json();
    if (data.ok) {
      setMsg("Guardado");
      setEditando(prev => { const n = {...prev}; delete n[key]; return n; });
      load();
    } else { setMsg("Error: " + JSON.stringify(data)); }
    setTimeout(() => setMsg(""), 3000);
  };

  const startEdit = (dia: number, turno: number, inicio: string, fin: string) => {
    setEditando(prev => ({ ...prev, [`${dia}-${turno}`]: { inicio, fin } }));
  };

  const card: React.CSSProperties = { background: "#1e2a3a", borderRadius: "8px", padding: "20px", marginBottom: "24px" };
  const storeBtnBase: React.CSSProperties = { padding: "8px 16px", borderRadius: "4px", border: "none", cursor: "pointer", fontWeight: "bold", marginRight: "8px", marginBottom: "8px" };

  return (
    <div style={{ padding: "24px" }}>
      <h2 style={{ color: "white", marginBottom: "24px" }}>Horarios por Local</h2>
      <div style={card}>
        <h3 style={{ color: "white", marginBottom: "12px" }}>Seleccionar local</h3>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {STORES.map(s => (
            <button key={s.id} onClick={() => setStoreSeleccionado(s.id)}
              style={{ ...storeBtnBase, background: storeSeleccionado === s.id ? "#3498db" : "#2c3e50", color: "white" }}>
              {s.name}
            </button>
          ))}
        </div>
      </div>
      <div style={card}>
        <h3 style={{ color: "white", marginBottom: "16px" }}>
          Horarios — {STORES.find(s => s.id === storeSeleccionado)?.name}
        </h3>
        {msg && <p style={{ color: msg.startsWith("Error") ? "#e74c3c" : "#2ecc71", marginBottom: "12px" }}>{msg}</p>}
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #333" }}>
              <th style={{ color: "#aaa", textAlign: "left", padding: "8px", width: "110px" }}>DIA</th>
              <th style={{ color: "#aaa", textAlign: "left", padding: "8px" }}>TURNOS</th>
              <th style={{ color: "#aaa", textAlign: "left", padding: "8px", width: "100px" }}>ESTADO</th>
            </tr>
          </thead>
          <tbody>
            {DIAS.map((dia, dIdx) => {
              const activo = isDiaActivo(storeSeleccionado, dIdx);
              const t1 = getHorario(storeSeleccionado, dIdx, 1);
              const t2 = getHorario(storeSeleccionado, dIdx, 2);
              return (
                <tr key={dIdx} style={{ borderBottom: "1px solid #222" }}>
                  <td style={{ color: "white", padding: "8px", fontWeight: "bold" }}>{dia}</td>
                  <td style={{ padding: "8px" }}>
                    {activo ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        {[{t: t1, k: `${dIdx}-1`, n: 1}, {t: t2, k: `${dIdx}-2`, n: 2}].map(({t, k, n}) => (
                          <div key={k} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ color: "#aaa", fontSize: "12px", width: "55px" }}>Turno {n}:</span>
                            {editando[k] ? (
                              <>
                                <input type="time" value={editando[k].inicio}
                                  onChange={e => setEditando(prev => ({...prev, [k]: {...prev[k], inicio: e.target.value}}))}
                                  style={{ background: "#0d1b2a", color: "white", border: "1px solid #444", borderRadius: "4px", padding: "4px" }} />
                                <span style={{ color: "#aaa" }}>-</span>
                                <input type="time" value={editando[k].fin}
                                  onChange={e => setEditando(prev => ({...prev, [k]: {...prev[k], fin: e.target.value}}))}
                                  style={{ background: "#0d1b2a", color: "white", border: "1px solid #444", borderRadius: "4px", padding: "4px" }} />
                                <button onClick={() => saveHorario(dIdx, n)}
                                  style={{ background: "#2ecc71", color: "white", border: "none", padding: "4px 10px", borderRadius: "4px", cursor: "pointer" }}>✓</button>
                                <button onClick={() => setEditando(prev => { const x = {...prev}; delete x[k]; return x; })}
                                  style={{ background: "#7f8c8d", color: "white", border: "none", padding: "4px 10px", borderRadius: "4px", cursor: "pointer" }}>✕</button>
                              </>
                            ) : (
                              <>
                                <span style={{ color: "white" }}>{t ? `${t.hora_inicio} - ${t.hora_fin}` : "Sin horario"}</span>
                                <button onClick={() => startEdit(dIdx, n, t?.hora_inicio || "09:00", t?.hora_fin || "13:00")}
                                  style={{ background: "#3498db", color: "white", border: "none", padding: "4px 10px", borderRadius: "4px", cursor: "pointer", fontSize: "12px" }}>Editar</button>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : <span style={{ color: "#555" }}>Cerrado</span>}
                  </td>
                  <td style={{ padding: "8px" }}>
                    <button onClick={() => toggleDia(dIdx, !activo)}
                      style={{ background: activo ? "#e74c3c" : "#2ecc71", color: "white", border: "none", padding: "4px 14px", borderRadius: "4px", cursor: "pointer", fontSize: "12px" }}>
                      {activo ? "Cerrar" : "Abrir"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
